import { Controller, useFormContext } from "react-hook-form";
import { NumberInput, NumberInputProps } from "./number-input";

export type ControlledNumberInputProps = Omit<
  NumberInputProps,
  "onValueChange" | "errorMessage"
> & {
  name: string;
};

export function ControlledNumberInput(props: ControlledNumberInputProps) {
  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      name={props.name}
      render={({ field, fieldState }) => {
        const { onChange, value, ...fieldProps } = field;

        return (
          <NumberInput
            {...fieldProps}
            {...props}
            errorMessage={fieldState?.error?.message}
            isInvalid={!!fieldState?.error}
            value={value?.toString() ?? ""}
            onValueChange={(nextValue: string) => {
              if (
                nextValue === "" ||
                nextValue === null ||
                nextValue === undefined
              ) {
                onChange(null);
                return;
              }

              const parsed = Number(nextValue);

              if (isNaN(parsed)) {
                return;
              }

              onChange(parsed);
            }}
          />
        );
      }}
    />
  );
}

ControlledNumberInput.displayName = "RecareUI.ControlledNumberInput";
